<template>
  <div class="w-full mb-10">

    <!--File upload - Multiple files -->
    <div v-if="this.allowMultipleFiles">
      <MultipleEconomyFileUpload :model="this.model" :preview="this.preview" :readOnly="this.readOnly"/>
    </div>

    <!--File upload - Single files -->
    <div v-else>
      <SingleEconomyFileUpload :model="model" :preview="this.preview" :readOnly="this.readOnly"/>
    </div>

    <!--Tables-->
    <div v-if="model.properties.tableSection" class="economytable mt-6">
      <Section :model="model.properties.tableSection"
               :pageId="pageId"
               :preview="preview"
               :readOnly="readOnly"/>
    </div>

  </div>
</template>
<script>
import Section from '@/views/components/schema/Section.vue';
import MultipleEconomyFileUpload from './MultipleEconomyFileUpload.vue';
import SingleEconomyFileUpload from './SingleEconomyFileUpload.vue';

export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
      required: false,
    },
    preview: {
      type: Boolean,
      required: false,
    },
    pageId: {
      type: String,
      required: false,
    },
  },
  components: {
    SingleEconomyFileUpload,
    MultipleEconomyFileUpload,
    Section,
  },
  data() {
    return {
      isMunicipality: false,
      allowMultipleFiles: false,
      tableSection: this.model.properties.tableSection,
    };
  },
  mounted() {
    this.isMunicipality = this.model.properties.isMunicipality;
    this.allowMultipleFiles = this.model.properties.allowMultipleFiles;
  },
  emits: ['onSave'],
};
</script>
